<section class="mt-4 w-full h-[calc(100%-79px)]">
  <section class="flex justify-between h-11 mb-4">
    <div class="w-[calc(100%-50px)] pl-5">
      <h4 class="!font-semibold truncate">Manage Members</h4>
      <p class="line-clamp-[1]">{{ this.entityName }}</p>
    </div>

    <button
      class="mr-2"
      mat-icon-button
      type="button"
      [mat-dialog-close]="true"
    >
      <i class="fa-light fa-xmark text-lg"></i>
    </button>
  </section>
  <!-- Section for Table Members Modal. -->
  <app-table-members
    [showUserOrganization]="true"
    [rithmId]="rithmId"
    [entityType]="isFolder ? entityType.BoardFolder : entityType.Board"
    [showAllMembers]="true"
    [displayedColumns]="displayedColumns"
    [isOpenFromBoardMembers]="true"
  />

  <section class="bottom-0 right-0 absolute pb-3 mr-4">
    <button mat-button type="button" [mat-dialog-close]="true">Close</button>
  </section>
</section>
